<template>
  <div class="card">
    <div class="card-body row">
      <div class="col-sm-12 col-xl-12">
        <crm-segments-blocks />
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <segments-migration-table />
    </div>
  </div>
</template>

<script>
import { useMixpanelConfig } from '@/utilities/mixpanel';

import SegmentsMigrationTable from '@/components/segments/groupsMigrationTable/AllSegmentGroupsMigrationTable.vue';
import CrmSegmentsBlocks from '@/components/segments/crmBlocks/CrmSegmentsBlocks.vue';

export default {
  name: 'Rfv',
  components: {
    CrmSegmentsBlocks,
    SegmentsMigrationTable,
  },
  mounted() {
    useMixpanelConfig('view_base_management_rfv');
  },
};
</script>
